import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { Button, Icon } from '@kontentino/ui';
import Footer from 'app/modules/posts/components/shiftPosts/Footer';
import TargetProfileForm from 'app/modules/posts/components/shiftPosts/TargetProfileForm';
import { STEPS, useShiftPosts } from 'app/modules/posts/hooks/useShiftPosts';
import Modal from 'components/shared/Modal';
import { PageData, PagesProjects } from 'types/Page';
import { ListPost } from 'types/PostDetail';
import { useEffectOnce } from 'utils/hooks/useEffectOnce';
import { useGetInitialTargetsToDuplicate } from '../hooks/useGetInitialTargetsToDuplicate';
import { useTranslation } from 'react-i18next';

type Props = {
  initialPosts: ListPost[];
  onFinish: () => void;
  pages: PageData[];
  initialProjects?: PagesProjects;
  postsProjects?: PagesProjects;
};

function DuplicatePostsPreselectedPosts(props: Props) {
  const { t } = useTranslation();
  const container = useShiftPosts({
    initialStep: STEPS.SELECT_TARGET_PROFILES.step,
    ...props,
  });

  const getInitialTargets = useGetInitialTargetsToDuplicate({
    initialPosts: props.initialPosts,
    initialProjects: props.initialProjects,
    postsProjects: props.postsProjects,
  });

  useEffectOnce(() => {
    const detectedInitialTargets = getInitialTargets();

    if (detectedInitialTargets.length) {
      container.setTargets(detectedInitialTargets);
    } else if (props.initialPosts.length > 1) {
      container.addTarget();
    }
  });

  container.targetHandlers.current = {};

  return (
    <>
      <Modal.Header title={t('duplicatePosts')} />
      <Modal.Content>
        {container.canShowTargetProfiles && (
          <div className="tw-mb-2 tw-flex tw-flex-col tw-gap-y-4">
            {container.targets.map((target, index) => (
              <TargetProfileForm
                key={target.id}
                selectedPosts={container.selectedPosts}
                dataNamePrefix="posts_duplicate-target"
                availablePages={props.pages}
                targetIndex={index + 1}
                initialTarget={target}
                ref={(ref) => {
                  if (ref) container.targetHandlers.current[target.id] = ref;
                }}
                removeTarget={
                  container.targets.length > 1
                    ? () => container.removeTarget(target.id)
                    : undefined
                }
                error={container.errors[target.id]}
              />
            ))}
          </div>
        )}

        {container.step === STEPS.SELECT_TARGET_PROFILES.step && (
          <Button
            variant="tertiary"
            onClick={container.addTarget}
            iconBefore={<Icon icon={faPlus} />}
          >
            {t('addProfile')}
          </Button>
        )}
      </Modal.Content>
      <Footer
        variant="duplicate"
        activeStep={container.step}
        canGoNext={container.canGoNext}
        onGoNext={container.goNext}
        onSubmit={container.onSubmit}
      />
    </>
  );
}

export default DuplicatePostsPreselectedPosts;
